import { Grid, IconButton, styled, Typography, useTheme } from "@mui/material";
import {
  ContactPhoneIcon,
  EmailIcon,
  InstagramIcon,
  TelegramIcon,
  WhatsAppIcon,
} from "assets/Icon";

function ContactUs() {
  const theme = useTheme();
  return (
    <>
      <Grid container justifyContent="space-evenly" pb={2}>
        <Grid item xs={12} display="flex" justifyContent="center">
          <Typography color="text.main" my={3}>
            Contact Us
          </Typography>
        </Grid>

        <Grid item>
          <ContactButton href="tel:+982122202080">
            <ContactPhoneIcon color={theme.palette.secondary.primary} />
          </ContactButton>
        </Grid>

        <Grid item>
          <ContactButton href="https://t.me/SanaCash">
            <TelegramIcon color={theme.palette.secondary.primary} />
          </ContactButton>
        </Grid>

        <Grid item>
          <ContactButton href="mailto: info@sanacash.net">
            <EmailIcon color={theme.palette.secondary.primary} size={24} />
          </ContactButton>
        </Grid>

        <Grid item>
          <ContactButton href="https://wa.me/+989381091635">
            <WhatsAppIcon color={theme.palette.secondary.primary} />
          </ContactButton>
        </Grid>
      </Grid>
    </>
  );
}

const ContactButton = styled(IconButton)(({ theme }) => ({
  background: theme.palette.secondary.light,
  borderRadius: "10px",
}));

export default ContactUs;
